export default {
  min: 'Min',
  max: 'Max'
}
